// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__332Lk","content":"styles_content__1yzZG","footer":"styles_footer__2EnTP"};